import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  bar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(26, 29, 41, 0.95)',
    backdropFilter: 'blur(8px)',
    padding: '0.875rem 2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
    animation: '$slideUp 0.25s ease-out',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    marginLeft: 'auto',
  },
  clearButton: {
    padding: '0.5rem 1rem',
    backgroundColor: 'transparent',
    color: 'rgba(255, 255, 255, 0.7)',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#fff',
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
  },
  migrateButton: {
    padding: '0.5rem 1.5rem',
    backgroundColor: '#4c4cff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 600,
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#3b3be0',
    },
  },
  migrateButtonDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  '@keyframes slideUp': {
    from: { transform: 'translateY(100%)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
  },
});

export default useStyles;
